import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useClient = () => {

    const getClientsByFilter = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/filter`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.itemsFind?.length > 0) return (result.payload);
        else return ({
            ...result.payload,
            itemsFind: []
        });
    }, []);

    const getDetailsClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/details`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload[0];
        else return {...result, payload: []};
    }, []);


    const updateDetailsClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/update`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload[0];
        else return {...result, payload: []};
    }, []);

    const getTypePlans = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/typePlans`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload;
        else return [];
    }, []);

    const getRolesBli = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/rolesBli`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload;
        else return [];
    }, []);

    const createClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/create`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result.payload.length > 0) {
            if (result.payload[0].Mensaje === 'USER_CREATED_SUCCESSFULLY') {
                return 'SIGNUP_SUCCESSFULLY';
            }
            else if (result.payload[0].Mensaje === 'USER_OR_EMAIL_ALREADY_EXIST') {
                if (result.payload[0].UsuarioValidator) return 'USERNAME_ALREADY_EXIST';
                if (result.payload[0].EmailValidator) return 'EMAIL_ALREADY_EXIST';
            }
        }
      
    }, [])

    const registerMovClientBalance = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/movBalance`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        return result
    }, []);

    const registerMovClientBalanceDetails = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/movBalanceDetails`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        return result
    }, []);


    const getAllPackagesByClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/packages`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload;
        else return {...result, payload: []};
    }, []);

    const getPlatformsAsignedClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/clients/platforms`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        const result = await response.json();
        if (result?.payload?.length > 0) return result.payload;
        else return  [];
        }, []);

        const saveAssignedPlatform = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/clients/platforms`, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal: signal
            });
            const result = await response.json();
            return result;
        }
        , []);

        // Sync manual de un cliente puntual (solo api de USA). Firma sin `signal` para poder usarse
        // desde BtnSync, igual que el resto de los sync de plataformas/paquetes.
        const syncClientToLocker = useCallback(async (data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/clients/sync`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                }
            });
            const result = await response.json();
            return result;
        }, []);

        // Sync de todos los clientes de un locker (solo api de USA). Es fire-and-forget del lado
        // del api: responde el ack y encola los clientes en background.
        const syncClientsByPlatform = useCallback(async (data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/clients/platform/sync`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                }
            });
            const result = await response.json();
            return result;
        }, []);

        const saveDeallocatePlatform = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/clients/platforms`, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                signal: signal
            });
            const result = await response.json();
            return result;
        }, []);


    return { getClientsByFilter, getDetailsClient, updateDetailsClient, getTypePlans, getRolesBli, createClient, registerMovClientBalance, registerMovClientBalanceDetails, getAllPackagesByClient, getPlatformsAsignedClient, saveAssignedPlatform, saveDeallocatePlatform, syncClientToLocker, syncClientsByPlatform };
}